var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAllDone = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 1453,
  height: 1280,
  viewBox: "0 0 1453 1280",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M606.299 365.27C608.542 389.981 618.097 416.377 639.841 428.371C666.118 442.87 699.025 431.02 724.669 415.462C765.279 390.896 799.893 357.804 835.043 325.917C881.796 283.529 930.694 242.73 983.152 207.759C1033.12 174.427 1092.06 151.21 1153.05 155.015C1180.89 156.749 1209.07 164.36 1231.15 181.411C1271.08 212.191 1283.66 267.199 1282.93 317.584C1281.9 383.382 1260.5 439.498 1238.17 499.757C1214.58 563.484 1187.96 626.055 1158.51 687.277C1115.85 775.907 1062.08 866.608 973.986 910.442C946.344 924.218 912.266 932.406 885.355 917.281C859.175 902.59 848.206 870.365 845.915 840.501C843.575 810.588 847.621 780.146 841.527 750.811C839.967 743.345 837.53 735.638 831.923 730.532C818.273 718.153 796.48 728.076 782.05 739.54C745.535 768.489 716.284 805.386 683.474 838.43C650.663 871.473 612.296 901.723 566.761 911.887C521.276 922.05 467.6 907.214 443.907 867.09C421.042 828.314 430.987 778.749 418.409 735.542C415.972 727.16 412.462 718.731 406.026 712.806C392.815 700.668 372.046 702.835 354.983 708.327C300.332 725.956 255.09 769.693 198.246 777.641C175.137 780.868 149.445 776.919 133.113 760.3C118.683 745.609 114.1 723.307 116.684 702.883C120.828 669.744 140.231 641.999 156.563 613.724C174.406 582.799 192.395 551.923 210.824 521.336C247.631 460.211 286.243 400.096 328.608 342.631C360.151 299.858 394.033 258.336 434.79 224.233C454.827 207.47 476.863 192.346 501.873 184.735C535.901 174.331 571.442 179.966 590.601 212.239C618.731 259.637 601.57 313.634 606.299 365.27Z",
  fill: "#D6DAE0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M115.349 640.492L0 848.345L265.328 992.321L380.677 784.469L115.349 640.492Z",
  fill: "#F4F5F7"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M77.001 824.32L136.873 716.468",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M85.2822 853.551L165.134 709.771",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M104.166 863.766L183.949 719.986",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M122.984 873.982L202.768 730.202",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M199.482 903.821L231.095 846.918",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M212.551 910.927L244.163 853.956",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M225.621 917.964L257.165 861.061",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M325.248 571.883L117.375 689.999L268.152 949.462L476.025 831.346L325.248 571.883Z",
  fill: "#F4F5F7"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M195.719 709.094L303.625 647.86",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M187.44 738.325L331.27 656.59",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M198.184 756.729L342.013 674.994",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M208.857 775.2L352.687 693.465",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M258.534 840.019L315.464 807.677",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M265.923 852.807L322.852 820.465",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M273.313 865.528L330.243 833.186",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M981.443 949.764H448.822C437.464 949.764 428.295 940.698 428.295 929.466V582.229H1001.97V929.466C1001.97 940.698 992.801 949.764 981.443 949.764Z",
  fill: "#243045"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M1001.97 582.228H428.297L400.448 296.427C399.284 284.519 408.727 274.167 420.838 274.167H1009.43C1021.54 274.167 1031.05 284.519 1029.89 296.427L1001.97 582.228Z",
  fill: "#243045"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M428.295 582.229H1001.97",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M494.805 832.44H451.013V853.686H494.805V832.44Z",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M477.904 666.127H451.013V687.373H477.904V666.127Z",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M699.122 832.44H568.978V853.686H699.122V832.44Z",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M676.814 869.584H568.977V935.96H676.814V869.584Z",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "M894.135 666.127H849.59V687.373H894.135V666.127Z",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M867.244 696.71H849.59V717.956H867.244V733.992H894.135V717.956V696.71H867.244Z",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M830.841 832.438H809.355V853.684H830.841V832.438Z",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  d: "M867.243 832.438H845.758V853.684H867.243V832.438Z",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "M867.243 801.246H845.758V822.492H867.243V801.246Z",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  d: "M901.044 832.438H879.559V853.684H901.044V832.438Z",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  d: "M981.1 549.48L980.006 562.403H444.922L443.759 549.48H981.1Z",
  fill: "#4F99BA"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  d: "M1003 296.969L991.023 434.998L988.559 463.957L981.101 549.48H443.759L433.29 428.367L429.732 387.567L421.863 296.969H1003Z",
  fill: "#62A8C7"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  d: "M600.452 879.735C597.099 877.232 592.378 878.179 588.409 879.532C572.193 885.148 561.313 896.448 547.012 905.04C542.838 907.544 538.527 909.709 534.148 911.739C541.264 901.454 548.381 891.238 555.565 880.885C570.14 859.91 582.662 835.146 593.61 811.939C595.731 807.405 597.852 802.669 597.784 797.662C597.715 792.655 594.841 787.31 589.983 786.024C583.414 784.265 577.461 789.949 573.219 795.159C568.224 801.248 563.366 807.405 558.508 813.63C566.924 800.436 574.861 786.904 582.183 773.169C584.372 769.041 586.562 764.846 587.178 760.245C587.793 755.645 586.63 750.57 583.004 747.593C579.925 745.089 575.545 744.48 571.645 745.225C563.639 746.781 557.618 753.209 552.349 759.366C545.028 767.959 537.775 776.552 530.659 785.28C537.364 774.996 543.933 764.576 550.16 754.021C553.992 747.593 557.413 738.594 551.939 733.452C546.875 728.715 538.527 731.625 532.848 735.549C521.695 743.263 513.142 753.818 505.136 764.711C511.842 753.75 515.263 743.465 507.668 739.338C502.81 736.699 497.678 739.067 493.367 741.436C467.708 755.441 453.544 782.1 437.874 805.646C416.731 837.312 400.241 869.654 383.75 903.755C371.844 928.451 350.085 973.243 339.821 994.286H480.503C482.624 990.903 484.745 987.52 486.867 984.136C496.72 979.874 507.394 977.167 517.11 972.16C519.232 971.078 521.216 969.928 523.132 968.777C537.227 960.117 547.149 948.614 558.713 936.503C571.645 923.038 587.725 912.686 598.81 897.395C600.726 894.688 602.642 891.847 603.326 888.599C604.01 885.486 603.121 881.765 600.452 879.735ZM466.818 815.728C471.266 809.706 475.713 803.684 480.229 797.662C482.077 795.159 486.046 790.558 490.562 785.009C482.761 795.226 474.619 805.511 466.818 815.728Z",
  fill: "#C96959"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  d: "M1184.67 879.734C1207.79 832.98 1169 763.086 1130.47 735.345C1116.52 725.331 1099.68 718.498 1082.23 718.362C1063.01 718.227 1043.3 727.023 1032.9 742.991C1024.21 756.32 1022.64 773.303 1025.65 788.865C1028.66 804.427 1035.98 818.907 1043.98 832.642C1051.37 845.295 1059.45 857.474 1068.21 869.247C1075.94 879.599 1084.29 889.68 1094.82 897.123C1108.92 907.069 1126.98 911.873 1144.09 908.964C1161.2 906.054 1177 895.161 1184.67 879.734Z",
  fill: "#243045"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  d: "M1045.63 729.865L1093.46 782.099",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  d: "M1037.55 821.071L1144.98 747.793",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  d: "M1064.51 747.659C1067.32 745.629 1071.22 746.103 1073.48 748.742L1086.13 763.357C1088.8 766.469 1088.05 771.138 1084.56 773.303L1083.88 773.709C1081 775.468 1077.24 774.791 1075.12 772.153L1063.14 757.132C1060.82 754.155 1061.43 749.892 1064.51 747.659Z",
  fill: "#F9F9F9"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  d: "M1327.4 994.488H1184.05C1181.93 991.105 1179.81 987.722 1177.69 984.339C1167.83 980.076 1157.16 977.369 1147.44 972.363C1145.32 971.28 1143.34 970.13 1141.42 968.98C1127.33 960.319 1117.4 948.816 1105.84 936.705C1092.91 923.241 1076.83 912.888 1065.74 897.597C1063.83 894.89 1061.91 892.049 1061.23 888.801C1060.54 885.553 1061.43 881.832 1064.1 879.802C1067.45 877.299 1072.17 878.246 1076.14 879.599C1092.36 885.215 1103.24 896.514 1117.54 905.107C1121.71 907.611 1126.03 909.776 1130.4 911.806C1123.29 901.521 1116.17 891.304 1108.99 880.952C1094.41 859.977 1081.89 835.213 1070.94 812.006C1068.82 807.472 1066.7 802.736 1066.77 797.729C1066.84 792.722 1069.71 787.377 1074.57 786.091C1081.14 784.332 1087.09 790.016 1091.33 795.225C1096.33 801.315 1101.19 807.472 1106.05 813.697C1097.63 800.503 1089.69 786.971 1082.37 773.236C1080.18 769.108 1077.99 764.913 1077.38 760.312C1076.76 755.711 1077.92 750.637 1081.55 747.66C1084.63 745.156 1089.01 744.547 1092.91 745.292C1100.91 746.848 1106.93 753.276 1112.2 759.433C1119.53 768.026 1126.78 776.619 1133.89 785.347C1127.19 775.062 1120.62 764.643 1114.39 754.087C1110.56 747.66 1107.14 738.661 1112.61 733.519C1117.68 728.782 1126.03 731.692 1131.7 735.616C1145.32 745.021 1155.17 758.756 1164.75 772.221C1175.02 786.7 1186.79 801.18 1197.8 815.659C1193.36 809.637 1188.91 803.615 1184.39 797.594C1177.34 788.053 1169.82 778.919 1163.25 769.108C1159.62 763.695 1153.53 756.388 1152.16 749.892C1149.56 737.443 1163.73 737.443 1171.12 741.503C1196.78 755.508 1210.94 782.167 1226.61 805.713C1247.75 837.378 1264.24 869.72 1280.73 903.822C1294.28 931.766 1319.74 979.941 1327.4 994.488Z",
  fill: "#C96959"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  d: "M1290.73 488.81L1072.19 570.955L1116.73 686.816L1335.27 604.671L1290.73 488.81Z",
  fill: "#F4F5F7"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  d: "M1276.18 509.656L1243.57 521.916L1250.67 540.383L1283.28 528.123L1276.18 509.656Z",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  d: "M1241.66 573.567L1293.39 554.148",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  d: "M1247.07 587.641L1298.8 568.223",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  d: "M1252.88 602.594L1304.55 583.175",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  d: "M810 423.369H613L621 489.571H804L810 423.369Z",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  d: "M828.718 488.247L794.848 486.894L814.28 514.905L818.796 506.583L838.092 516.8L843.498 506.854L824.202 496.637L828.718 488.247Z",
  fill: "#243045"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  d: "M650.984 461.239C650.984 462.055 651.12 462.769 651.426 463.313C651.698 463.891 652.106 464.367 652.582 464.707C653.058 465.047 653.636 465.319 654.316 465.489C654.962 465.659 655.642 465.727 656.356 465.727C656.832 465.727 657.342 465.693 657.886 465.625C658.43 465.557 658.94 465.387 659.416 465.149C659.892 464.945 660.266 464.639 660.606 464.231C660.912 463.823 661.082 463.313 661.082 462.701C661.082 462.055 660.844 461.511 660.436 461.103C660.028 460.695 659.484 460.355 658.804 460.083C658.124 459.811 657.342 459.573 656.492 459.369C655.608 459.165 654.758 458.961 653.874 458.689C652.956 458.485 652.072 458.213 651.222 457.873C650.338 457.533 649.59 457.125 648.91 456.581C648.23 456.071 647.652 455.425 647.244 454.643C646.836 453.861 646.632 452.909 646.632 451.787C646.632 450.563 646.87 449.475 647.414 448.557C647.958 447.639 648.638 446.857 649.522 446.245C650.372 445.633 651.358 445.191 652.446 444.885C653.534 444.613 654.622 444.443 655.71 444.443C656.968 444.443 658.192 444.613 659.348 444.885C660.504 445.157 661.558 445.633 662.476 446.245C663.36 446.891 664.074 447.707 664.618 448.693C665.162 449.679 665.434 450.869 665.434 452.263H660.266C660.198 451.549 660.062 450.971 659.79 450.461C659.518 449.985 659.178 449.611 658.77 449.339C658.328 449.101 657.818 448.897 657.274 448.761C656.73 448.659 656.118 448.625 655.472 448.591C655.03 448.591 654.588 448.659 654.18 448.727C653.738 448.829 653.33 448.999 652.99 449.203C652.65 449.441 652.344 449.713 652.14 450.053C651.902 450.393 651.8 450.835 651.8 451.345C651.8 451.821 651.868 452.229 652.072 452.501C652.242 452.807 652.582 453.079 653.126 453.317C653.67 453.589 654.384 453.827 655.336 454.065C656.288 454.337 657.512 454.643 659.042 455.017C659.484 455.119 660.096 455.289 660.912 455.527C661.728 455.765 662.51 456.139 663.326 456.649C664.108 457.193 664.788 457.873 665.366 458.757C665.944 459.641 666.25 460.729 666.25 462.089C666.25 463.211 666.012 464.231 665.604 465.183C665.162 466.135 664.516 466.985 663.666 467.665C662.816 468.345 661.762 468.889 660.504 469.263C659.246 469.671 657.784 469.841 656.152 469.841C654.792 469.841 653.5 469.705 652.242 469.365C650.984 469.025 649.862 468.515 648.91 467.801C647.958 467.121 647.176 466.203 646.632 465.115C646.054 464.027 645.782 462.735 645.816 461.239H650.984ZM690.03 460.117C690.03 463.415 689.112 465.863 687.276 467.461C685.44 469.059 682.89 469.841 679.66 469.841C676.362 469.841 673.812 469.059 672.01 467.461C670.208 465.897 669.324 463.449 669.324 460.117V445.021H674.662V460.117C674.628 460.797 674.696 461.443 674.832 462.055C674.934 462.701 675.172 463.279 675.546 463.755C675.886 464.231 676.396 464.639 677.042 464.945C677.688 465.251 678.572 465.387 679.66 465.387C681.564 465.387 682.856 464.979 683.604 464.129C684.318 463.279 684.692 461.953 684.692 460.117V445.021H690.03V460.117ZM699.965 454.847H705.371C706.323 454.847 707.105 454.643 707.717 454.167C708.329 453.725 708.635 452.977 708.635 451.957C708.635 451.413 708.533 450.937 708.329 450.563C708.125 450.223 707.853 449.917 707.513 449.713C707.173 449.543 706.765 449.373 706.323 449.305C705.881 449.237 705.439 449.203 704.963 449.169H699.965V454.847ZM694.627 445.021H706.051C707.207 445.021 708.261 445.123 709.213 445.327C710.165 445.531 710.981 445.871 711.661 446.347C712.341 446.823 712.851 447.435 713.225 448.183C713.599 448.965 713.803 449.917 713.803 451.039C713.803 452.263 713.497 453.283 712.953 454.099C712.409 454.915 711.593 455.595 710.505 456.105C712.001 456.547 713.089 457.295 713.837 458.383C714.585 459.471 714.959 460.763 714.959 462.259C714.959 463.483 714.721 464.571 714.245 465.455C713.769 466.339 713.123 467.087 712.307 467.631C711.491 468.209 710.573 468.617 709.553 468.889C708.533 469.161 707.479 469.297 706.391 469.297H694.627V445.021ZM699.965 465.149H705.677C706.187 465.149 706.697 465.115 707.173 465.013C707.649 464.911 708.057 464.741 708.431 464.503C708.771 464.265 709.077 463.925 709.281 463.517C709.485 463.109 709.621 462.599 709.621 461.953C709.621 460.729 709.247 459.845 708.567 459.301C707.853 458.757 706.935 458.519 705.779 458.485H699.965V465.149ZM718.567 445.021H726.081L731.759 461.715H731.827L737.199 445.021H744.713V469.297H739.715V452.093H739.647L733.697 469.297H729.583L723.633 452.263H723.565V469.297H718.567V445.021ZM749.412 445.021H754.75V469.297H749.412V445.021ZM764.812 449.509H757.536V445.021H777.426V449.509H770.15V469.297H764.812V449.509Z",
  fill: "white"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  d: "M144 13.5225C185.324 -2.10776 232.059 -0.324467 274.072 13.3651C316.086 27.0547 353.591 52.0736 386.268 81.4984C410.829 103.633 433.533 129.438 443.877 160.646C454.222 191.907 449.872 229.566 426.107 252.592C419.157 259.306 409.609 264.865 400.113 262.82C390.087 260.669 383.456 250.337 382.873 240.266C382.289 230.143 386.48 220.335 391.679 211.628C421.544 161.276 485.997 136.152 544.296 145.226C602.596 154.3 653.468 193.847 683.758 243.938C714.048 294.028 725.401 353.664 724.552 412.042",
  stroke: "#243045",
  strokeWidth: 4.1402,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  },
  opacity: 0.1
}, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  d: "M292.615 948.236L125.148 700.037L49 808.726L125.148 990.335L292.615 948.236Z",
  fill: "url(#paint0_linear_225_5)"
}))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M1187 862.5L1143 802L1124.5 774.5L1118 756L1134 748L1165 774.5L1192.5 814L1187 862.5Z",
  fill: "url(#paint1_linear_225_5)"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M1154 879.5L1110 819L1091.5 791.5L1085 773L1101 765L1132 791.5L1159.5 831L1154 879.5Z",
  fill: "url(#paint2_linear_225_5)"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M452.084 826.596L498.937 768.278L520.628 743.218L536.778 732.097L548.691 745.441L531.242 782.302L500.33 819.193L452.084 826.596Z",
  fill: "url(#paint3_linear_225_5)"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M484.769 840.038L531.623 781.72L553.313 756.659L569.463 745.538L581.377 758.882L563.928 795.744L533.015 832.635L484.769 840.038Z",
  fill: "url(#paint4_linear_225_5)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_225_5",
  x1: 258.476,
  y1: 885.655,
  x2: 169.789,
  y2: 967.025,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.148362,
  stopColor: "#384272"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_225_5",
  x1: 1160.5,
  y1: 824.5,
  x2: 1188,
  y2: 808,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B33F1B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7A889",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_225_5",
  x1: 1127.5,
  y1: 841.5,
  x2: 1155,
  y2: 825,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B33F1B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7A889",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_225_5",
  x1: 481.81,
  y1: 791.063,
  x2: 504.941,
  y2: 813.278,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B33F1B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7A889",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_225_5",
  x1: 514.496,
  y1: 804.505,
  x2: 537.626,
  y2: 826.719,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B33F1B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7A889",
  stopOpacity: 0
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAllDone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/allDone.a24484c45c1a62e4f34574145ab2a9a6.svg";